import { TableauViz, VizFilter } from "@tableau/embedding-api-react";
import { styled } from "@mui/material/styles";
import { Theme } from "@mui/material/styles";
import MDBox from "./MDBox";

export interface TableauProps {
  id?: string;
  src: string;
  token?: string;
  width?: string;
  height?: string;
  device?: "phone" | "desktop" | "default";
  toolbar?: "hidden";
  vizFilters?: VizFilter[];
}

const TableauEmbed: React.FC<TableauProps> = ({ src, device, height, width, token, vizFilters }) => {
  return (
    <CardContainer>
      <div>
        <TableauViz
          toolbar="hidden"
          device={device ?? "default"}
          src={src}
          width={width}
          height={height}
          token={token}
          vizFilters={vizFilters}
        />
      </div>
    </CardContainer>
  );
};

const CardContainer = styled(MDBox)(({ theme }: { theme: Theme }) => ({
  display: "flex",
  flexDirection: "column",
  overflow: "hidden",
  gap: theme.spacing(0.6),
  padding: theme.spacing(1),
  borderRadius: theme.spacing(1.5),
  backgroundColor: theme.palette.background.default,
  boxShadow: theme.shadows[2],
}));

export default TableauEmbed;
